import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import './InlinePillSelect.scss';

/**
 * InlinePillSelect — 彩色 pill 形式的下拉選擇（無外框，點 pill 展開選單）
 * 供工作項目「類型 / 優先度 / 狀態」等統一使用。
 *
 * @param {ReactNode} trigger  外部傳入的 pill 顯示（自帶背景色）
 * @param {Array}     options  [{ value, label, color? }]
 * @param {*}         value    目前選中值
 * @param {Function}  onChange (value) => void
 */
// 共用的下拉小箭頭（放在 pill 內，跟隨 pill 文字色）
export const PillCaret = () => (
  <svg className="ips-caret" width="9" height="9" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 5l3 3 3-3" strokeLinecap="round" strokeLinejoin="round" /></svg>
);

const InlinePillSelect = ({ trigger, options, value, onChange }) => {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState(null);
  const btnRef = useRef(null);
  const openMenu = () => {
    const r = btnRef.current?.getBoundingClientRect();
    if (r) setPos({ top: r.bottom + 6, left: r.left });
    setOpen(true);
  };
  return (
    <div className="ips">
      <button ref={btnRef} type="button" className="ips-trigger" onClick={() => (open ? setOpen(false) : openMenu())}>{trigger}</button>
      {open && pos && ReactDOM.createPortal(
        <>
          <div className="ips-ov" onClick={() => setOpen(false)} />
          <div className="ips-menu" style={{ top: pos.top, left: pos.left }}>
            {options.map((o) => (
              <button
                key={String(o.value)}
                type="button"
                className={o.value === value ? 'active' : ''}
                onClick={() => { onChange(o.value); setOpen(false); }}
              >
                {o.color && <span className="ips-dot" style={{ background: o.color }} />}
                {o.label}
              </button>
            ))}
          </div>
        </>, document.body)}
    </div>
  );
};

export default InlinePillSelect;
